import { DumpsterSize, DumpsterLocationType, DumpsterFillStatus, Dumpster } from "../../../models";
import { DumpsterForm } from "../TriplePInterface";

export interface DumpsterPayload {
  data: {
    type: string;
    attributes: {
      label: string;
      dumpster_size: DumpsterSize;
      notes?: string;
      fill_status: DumpsterFillStatus;
    };
  };
}

export const toDumpster = (form: DumpsterForm): DumpsterPayload => {
  return {
    data: {
      type: "dumpsters",
      attributes: {
        label: form.label,
        dumpster_size: form.dumpsterSize,
        notes: form.notes,
        fill_status: form.fillStatus,
      },
    },
  };
};

export interface UpdateDumpsterPayload {
  data: {
    id: string;
    type: string;
    attributes: {
      label: string;
      dumpster_size: DumpsterSize;
      notes?: string;
      fill_status: DumpsterFillStatus;
      location_type: DumpsterLocationType;
      current_order_id?: string;
      current_storage_yard_id?: string;
      current_address: string;
      current_city: string;
      current_zip: string;
    };
  };
}

export const toUpdateDumpster = (dumpster: Dumpster): UpdateDumpsterPayload => {
  return {
    data: {
      id: dumpster.id,
      type: "dumpsters",
      attributes: {
        label: dumpster.label,
        dumpster_size: dumpster.dumpsterSize,
        notes: dumpster.notes,
        fill_status: dumpster.fillStatus,
        location_type: dumpster.locationType,
        current_order_id: dumpster.currentOrderId,
        current_storage_yard_id: dumpster.currentStorageYardId,
        current_address: dumpster.currentAddress,
        current_city: dumpster.currentCity,
        current_zip: dumpster.currentZip,
      },
    },
  };
};
